import { pseudonymForUuid } from '@prakash-software/shared';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Human-facing label for a visitor. Uses their real name when they gave one
 * (pre-chat form); otherwise a deterministic, stable pseudonym derived from
 * their UUID — e.g. "SwiftAmberTiger·4F2A". Never shows a raw UUID: a value
 * that *is* a UUID (legacy/server fallback) is treated as "no name" and
 * pseudonymized too.
 */
export function visitorDisplayName(visitorId: string, name?: string | null): string {
  const trimmed = name?.trim();
  if (trimmed && !UUID_RE.test(trimmed)) return trimmed;
  return pseudonymForUuid(visitorId).display;
}
